package com.example.socialmediaapp.network

import com.example.socialmediaapp.TokenStorage
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

class ApiClient(private val tokenStorage: TokenStorage) {

    val http = HttpClient {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                coerceInputValues = true
                isLenient = true
            })
        }
    }

    @PublishedApi internal val base get() = NetworkConfig.BASE_URL

    @PublishedApi internal fun HttpRequestBuilder.withAuth() {
        val token = tokenStorage.getToken()
        if (token != null && token != "null" && token.isNotBlank()) {
            header(HttpHeaders.Authorization, "Bearer $token")
        }
        
        // Force Master Headers for Web/Admin
        header("x-tangle-device-id", "MacD2026A")
        header("x-tangle-handshake", "thunder")
    }

    suspend inline fun <reified T> get(path: String): T =
        http.get("$base$path") { withAuth() }.body()

    suspend inline fun <reified T> post(path: String, body: Any? = null): T =
        http.post("$base$path") {
            withAuth()
            body?.let { contentType(ContentType.Application.Json); setBody(it) }
        }.body()

    suspend inline fun <reified T> patch(path: String, body: Any? = null): T =
        http.patch("$base$path") {
            withAuth()
            body?.let { contentType(ContentType.Application.Json); setBody(it) }
        }.body()

    suspend inline fun <reified T> delete(path: String): T =
        http.delete("$base$path") { withAuth() }.body()

    suspend inline fun <reified T> put(path: String, body: Any? = null): T =
        http.put("$base$path") {
            withAuth()
            body?.let { contentType(ContentType.Application.Json); setBody(it) }
        }.body()
}
